<template>
  <el-table-column
    v-bind="$attrs"
    v-on="$listeners"
    :prop="prop"
    :label="label"
    :width="width"
    :render-header="withTooltip('Номер автомата')"
  >
    <template slot-scope="{row}">
      <router-link :to="to(row)" v-if="$root.checkPermission('web_ta_main')" :style="colorStyle(row)">
        {{serialNumber(row)}}
      </router-link>
      <div v-else>
        {{serialNumber(row)}}
      </div>
    </template>
  </el-table-column>
</template>

<script>
  import get from 'lodash/get'
  import trimStart from 'lodash/trimStart'
  import withTooltip from '../with-tooltip'

  export default {
    props: {
      prop: {
        type: String,
        default: 'serial_number',
      },
      label: {
        type: String,
        default: '№ ТА',
      },
      width: {
        type: Number,
        default: 100,
      },
      idProp: {
        type: String,
        default: 'id',
      },
      machineProp: {
        type: String,
        default: '',
      },
    },
    methods: {
      withTooltip,
      to (row) {
        const id = get(row, trimStart(`${this.machineProp}.id`, '.'))
        return `/machines/${id}`
      },
      serialNumber (row) {
        return get(row, trimStart(`${this.machineProp}.serial_number`, '.'))
      },
      colorStyle (row) {
        const color = get(row, trimStart(`${this.machineProp}.category.color`, '.'), false)
        let style = ""
        if (color) {
          style = "color: " + color + ";"
        }
        return style
      }
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/table-column-serial-number.vue